import SetData from "@/vuex/SetData";
import Logger from "@/assets/Helper/Logger";
import Config from "@/vuex/Config";
import Status from "@/vuex/Status";

class ShoppingCart {

    add() {
        if (typeof window.conf2020AppConfig.shoppingCartUrl.add === 'string' && window.conf2020AppConfig.shoppingCartUrl.add !== "") {
            Status.dispatch('setLoading', true);

            let form = document.createElement('form');
            form.action = window.conf2020AppConfig.shoppingCartUrl.add;
            form.method = "POST";

            if (Config.getters.isShopLoginActive) {
                form.target = '_blank';
                Status.dispatch('setLoading', false);
            }

            let formData = document.createElement('input');
            formData.type = 'hidden';
            formData.name = 'items';
            formData.value = JSON.stringify(SetData.getters.getShoppingCartData);
            form.appendChild(formData);

            document.body.appendChild(form);
            form.submit();
        } else {
            Logger.error('Invalid shopping cart url for action: add');
        }
    }

    requestService() {
        if (this.isRequestServicePossible()) {
            Status.dispatch('setLoading', true);

            let form = document.createElement('form');
            form.action = window.conf2020AppConfig.shoppingCartUrl.requestService;
            form.method = "POST";

            let formData = document.createElement('input');
            formData.type = 'hidden';
            formData.name = 'items';
            formData.value = JSON.stringify(SetData.getters.getShoppingCartData);
            form.appendChild(formData);

            document.body.appendChild(form);
            form.submit();
        } else {
            Logger.error('Invalid shopping cart url for action: request service');
        }
    }

    isRequestServicePossible() {
        if (window.conf2020AppConfig.shoppingCartUrl &&
            typeof window.conf2020AppConfig.shoppingCartUrl.requestService === 'string' &&
            window.conf2020AppConfig.shoppingCartUrl.requestService !== ""
        ) {
            return true;
        }
        return false;
    }
}

export default new ShoppingCart();